const danhSachVanBanDen = (state) => state.danhSachVanBanDen;
const danhSachHienThiCotVanBanDen = (state) =>
  state.danhSachHienThiCotVanBanDen;
const danhSachHienThiCotVanBanDenCapNhat = (state) =>
  state.danhSachHienThiCotVanBanDenCapNhat;
const danhSachTatCaTrangThai = (state) => state.danhSachTatCaTrangThai;
const danhSachDonViThuHoi = (state) => state.danhSachDonViThuHoi;
const nguoiBiTraLai = (state) => state.nguoiBiTraLai;
const danhSachLoaiVanBan = (state) => state.danhSachLoaiVanBan;
const danhSachSoVanBan = (state) => state.danhSachSoVanBan;
const danhSachPhuongThucNhan = (state) => state.danhSachPhuongThucNhan;
const danhSachLoaiVanBanChuaVaoSo = (state) =>
  state.danhSachLoaiVanBanChuaVaoSo;
const danhSachDoKhan = (state) => state.danhSachDoKhan;
const dateFilterTable = (state) => state.dateFilterTable;
const danhSachDonViNgoai = (state) => state.danhSachDonViNgoai;
const danhSachDonViNgoaiKhongLienThong = (state) => state.danhSachDonViNgoaiKhongLienThong
const chiTietVanBanDen = (state) => state.chiTietVanBanDen;
const danhSachFileVanBanDen = (state) => state.danhSachFileVanBanDen;
const danhSachOptionDonVi = (state) => state.danhSachOptionDonVi;
const danhSachXemLuongPhanXuLy = (state) => state.danhSachXemLuongPhanXuLy;
const danhSachYKienVanBan = (state) => state.danhSachYKienVanBan;
const danhSachCanBoXinYKien = (state) => state.danhSachCanBoXinYKien;
const danhSachLanhDaoDonVi = (state) => state.danhSachLanhDaoDonVi;
const danhSachNhomLamViec = (state) => state.danhSachNhomLamViec;
const dataFilterDashboard = (state) => state.dataFilterDashboard;
const danhSachDonViCaNhanPXL = (state) => state.danhSachDonViCaNhanPXL;
const danhSachSoByDonVi =(state) => state.danhSachSoByDonVi
const getPageIndex =(state) => state.pageIndex
const getKeepAlivePage =(state) => state.keepAlivePage

export default {
  getPageIndex,
  dateFilterTable,
  getKeepAlivePage,
  dataFilterDashboard,
  danhSachVanBanDen,
  danhSachHienThiCotVanBanDen,
  danhSachHienThiCotVanBanDenCapNhat,
  danhSachTatCaTrangThai,
  danhSachDonViThuHoi,
  nguoiBiTraLai,
  danhSachLoaiVanBan,
  danhSachSoVanBan,
  danhSachPhuongThucNhan,
  danhSachLoaiVanBanChuaVaoSo,
  danhSachDoKhan,
  danhSachDonViNgoai,
  danhSachDonViNgoaiKhongLienThong,
  danhSachOptionDonVi,
  danhSachFileVanBanDen,
  chiTietVanBanDen,
  danhSachXemLuongPhanXuLy,
  danhSachYKienVanBan,
  danhSachCanBoXinYKien,
  danhSachLanhDaoDonVi,
  danhSachNhomLamViec,
  danhSachDonViCaNhanPXL,
  danhSachSoByDonVi
};
